module.exports = "<div class=c-markdown-key> <h2>Pricing</h2> <p>Each individual pricing rule can have a global pricing change set, which overrides any individual values set on events below. This allows you to create a single group for multiple events with one pricing rule.</p> <p>If only the pricing type global is selected, the values can be set individually by event below.</p> <p>If neither global values are set you can create custom pricing rules per event on that rule for this period.</p> </div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/base/views/period.cheatsheet.html
// module id = 507
// module chunks = 0